// extracted by mini-css-extract-plugin
export default {"App":"App_App__7BBxi","container":"App_container__mB9ij","top":"App_top__x6pHf","bottom":"App_bottom__CUNot"};